// React
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Route, Routes, useNavigate } from 'react-router-dom'

import MuiCssBaseline from '@mui/material/CssBaseline'

// Components
import AppLayout from '../components/app-layout'
import Campaigns from '../features/campaigns'
import CampaignDetails from '../features/campaigns/components/campaignDetails'
import Clients from '../features/clients'
import ClientDetails from '../features/clients/components/clientDetails'
import Dashboard from '../features/dashboard'
import Dispositions from '../features/dispositions'
import Fields from '../features/fields'
import Home from '../features/home'
import Imports from '../features/imports'
import ImportDetails from '../features/imports/components/importDetails'
import Login from '../features/login'
import Logout from '../features/logout'
import Prospects from '../features/prospects'
import Users from '../features/users'
// import NotFound from '../components/not-found'

import { ROUTES } from '../constants/routes'

function AppRoutes() {
  const { user } = useSelector((state) => state.persisted?.auth)
  const navigate = useNavigate()

  useEffect(() => {
    if (!user) {
      navigate(ROUTES.LOGIN)
    }
    if (user && window.location.pathname === `${ROUTES.LOGIN}`) navigate(ROUTES.DASHBOARD)
    if (user && window.location.pathname === `${ROUTES.HOME}`) navigate(ROUTES.DASHBOARD)
  }, [user, navigate])

  return (
    <>
      <MuiCssBaseline />
      <Routes>
        <Route path="/" element={<AppLayout />}>
          <Route path={ROUTES.HOME} element={<Home />}></Route>
          <Route path={ROUTES.DASHBOARD} element={<Dashboard />}></Route>
          <Route path={ROUTES.LOGIN} element={<Login />}></Route>
          <Route path={ROUTES.LOGOUT} element={<Logout />}></Route>
          <Route path={ROUTES.CAMPAIGNS} element={<Campaigns />}></Route>
          <Route path={ROUTES.CAMPAIGNS.concat('/:campaignId')} element={<CampaignDetails />}></Route>
          <Route path={ROUTES.CLIENTS} element={<Clients />}></Route>
          <Route path={ROUTES.CLIENTS.concat('/:clientId')} element={<ClientDetails />}></Route>
          <Route path={ROUTES.FIELDS} element={<Fields />}></Route>
          <Route path={ROUTES.DISPOSITIONS} element={<Dispositions />}></Route>
          <Route path={ROUTES.PROSPECTS} element={<Prospects />}></Route>
          <Route path={ROUTES.PROSPECTS_IMPORTS} element={<Imports />}></Route>
          <Route path={ROUTES.PROSPECTS_IMPORTS.concat('/:importId')} element={<ImportDetails />} />
          <Route path={ROUTES.USERS} element={<Users />}></Route>
          {/* <Route path="*" element={<NotFound />} /> */}
        </Route>
      </Routes>
    </>
  )
}

export default AppRoutes
